import Vue from 'vue'

import NrwFooterTerm from './NrwFooterTerm'
import NrwPrivacyPolicy from './NrwPrivacyPolicyModal'

const methods = {
  // Nrw 헤더 참조 설정
  setNrwHeader (obj) {
    Vue.prototype.$nrwHeader = obj
  },

  setNrwTotalSearchMain (obj) {
    Vue.prototype.$nrwTotalSearchMain = obj
  },

  // 약관 팝업
  async openTerm (el) {
    await Vue.prototype.$popup.openModal(el, NrwFooterTerm, {} )
  },

  // 이용 정책 팝업
  async openPolicy  (el) {
    await Vue.prototype.$popup.openModal(el, NrwPrivacyPolicy, {} )
  },

  // 오픈 소스 라이선스 팝업
  openSourceLicense  () {
    location.href = 'https://www.multicampus.com/main/content/sub/OSLNotice'
  }
}

export default {
  install (Vue) {
    if (!window.vue.$openTerm) window.vue.$openTerm = methods.openTerm
    if (!window.vue.$openPolicy) window.vue.$openPolicy = methods.openPolicy
    if (!window.vue.$openSourceLicense) window.vue.$openSourceLicense = methods.openSourceLicense

    Vue.prototype.$setNrwHeader = methods.setNrwHeader
    Vue.prototype.$setNrwTotalSearchMain = methods.setNrwTotalSearchMain
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/nrw/layouts/NrwCommon.js